import { Component, OnInit, ContentChildren, ContentChild, QueryList, OnDestroy, Input } from '@angular/core';

import { TileComponent } from './tile.component';
import { DashboardTilesRegistry } from '../services/DashboardTilesRegistry';
import { Observable } from 'rxjs';
import { TileDescriptor } from '../services/TileDescriptor';

@Component({
  selector: 'plr-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  private _name: string;
  private _tab: string;
  tiles: Observable<TileDescriptor[]>;
  Math: any = Math;

  @Input()
  set name(name: string){
    this._name = name;
    this.tiles = this.dashboardTilesRegistry.getTiles(this._name, this._tab);
  }
  get name(): string {
    return this._name;
  }

  @Input()
  set tab(tabName: string) {
    this._tab = tabName;
    this.tiles = this.dashboardTilesRegistry.getTiles(this._name, this._tab);
  }

  get tab(): string {
    return this._tab;
  }

  @Input()
  hasFullScreenTile: boolean = false;

  constructor(private dashboardTilesRegistry: DashboardTilesRegistry){
    
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/components/dashboard.component.ts